import { defineComponent as _defineComponent } from 'vue'
import SettingsHeader from '@/components/trip/settings/SettingsHeader.vue'
import ProExpansionPanel from '@/components/trip/settings/expansionPanels/ProExpansionPanel.vue'
import GeneralExpansionPanel from '@/components/trip/settings/expansionPanels/GeneralExpansionPanel.vue'
import ExportExpansionPanel from '@/components/trip/settings/expansionPanels/ExportExpansionPanel.vue'
import ActionsExpansionPanel from '@/components/trip/settings/expansionPanels/ActionsExpansionPanel.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TripSettings',
  setup(__props) {


return { __sfc: true,SettingsHeader, ProExpansionPanel, GeneralExpansionPanel, ExportExpansionPanel, ActionsExpansionPanel }
}

})